<template>
  <div>
    <v-row align="center" class="pa-4">
      <v-card-title class="pb-4 pr-8">Журнал редактирования и удаления гос номеров</v-card-title>
      <v-spacer></v-spacer>
    </v-row>
    <v-col cols="12" sm="7" md="8" lg="7" class="py-0 mb-6">
      <v-row class="mb-2" align="center">
        <v-menu
          v-model="menuFilterDate"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="230px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateRangeFilter"
              label="Промежуток времени"
              outlined
              dense
              hide-details
              style="max-width: 400px;"
              class="input input-search mr-2 pl-3"
              v-on="on"
              prepend-inner-icon="mdi-calendar"
              readonly
            />
          </template>
          <v-date-picker v-model="dateFilter" range :max="today">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuFilterDate = false">
              Назад
            </v-btn>
            <v-btn text color="primary" :disabled="!dateFilter[0]" @click="dateFilter = []">
              Сбросить
            </v-btn>
            <v-btn text color="primary" @click="menuFilterDate = false">
              Выбрать
            </v-btn>
          </v-date-picker>
        </v-menu>
        <v-select
          v-model="filters.action_type"
          :items="actionTypeItems"
          label="Тип действия"
          outlined
          dense
          hide-details
          clearable
          style="max-width: 250px;"
          class="mr-2"
        />
        <v-btn color="primary" class="text-none ml-4" @click="loadHistory">
          Поиск
        </v-btn>
      </v-row>
    </v-col>
    <v-data-table
      class="table"
      :headers="headers"
      :items="items"
      :loading="loading"
      :server-items-length="pagination.total"
      :options.sync="tableOptions"
      :footer-props="{
        'items-per-page-options': [10, 15, 20, 50],
        showFirstLastPage: true,
      }"
      @update:options="onOptionsUpdate"
    >
      <template v-slot:item.action_type="{ item }">
        <span :class="item.action_type === 'edit' ? 'primary--text' : 'error--text'">
          {{ item.action_type === 'edit' ? 'Редактирование' : 'Удаление' }}
        </span>
      </template>
      <template v-slot:item.deactivated_at="{ item }">
        {{ formatDateTime(item.deactivated_at) }}
      </template>
      <template v-slot:item.client_telephone="{ item }">
        {{ formatPhoneNumber(item.client_telephone) }}
      </template>
      <template v-slot:item.barrier_address="{ item }">
        <router-link v-if="item.barrier_id" :to="`/barrier/${item.barrier_id}`" class="routerLink">
          {{ item.barrier_address || '—' }}
        </router-link>
        <span v-else>—</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';

export default {
  name: 'CarNumberChangesHistoryClient',
  mixins: [ruDateFormatMixin],
  props: ['id'],
  data () {
    return {
      loading: false,
      menuFilterDate: false,
      dateFilter: [],
      today: new Date().toISOString().split('T')[0],
      filters: {
        action_type: null,
      },
      items: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 15,
        total: 0,
      },
      tableOptions: {
        page: 1,
        itemsPerPage: 15,
      },
      actionTypeItems: [
        { text: 'Редактирование', value: 'edit' },
        { text: 'Удаление', value: 'remove' },
      ],
      headers: [
        { text: 'Гос номер', value: 'car_number', sortable: false, width: '12%' },
        { text: 'Действие', value: 'action_type', sortable: false, width: '12%' },
        { text: 'Дата и время', value: 'deactivated_at', sortable: false, width: '14%' },
        { text: 'Клиент', value: 'client_name', sortable: false, width: '15%' },
        { text: 'Телефон', value: 'client_telephone', sortable: false, width: '14%' },
        { text: 'Шлагбаум', value: 'barrier_name', sortable: false, width: '15%' },
        { text: 'Адрес шлагбаума', value: 'barrier_address', sortable: false },
      ],
    };
  },
  computed: {
    dateRangeFilter () {
      let formattedStartDate = '';
      let formattedEndDate = '';
      if (this.dateFilter[0]) {
        formattedStartDate = this.ruDateFormat(this.dateFilter[0], true);
      }
      if (this.dateFilter[1]) {
        formattedEndDate = ` - ${this.ruDateFormat(this.dateFilter[1], true)}`;
      }
      return `${formattedStartDate}${formattedEndDate}`;
    },
  },
  created () {
    this.loadHistory();
  },
  methods: {
    ...mapActions({
      getCarNumberChangesHistory: 'Client/getCarNumberChangesHistory',
    }),
    formatDateTime (value) {
      if (!value) return '—';
      return this.ruDateFormat(value, false, true);
    },
    formatPhoneNumber (phone) {
      if (!phone) return '—';
      const digits = String(phone).replace(/\D/g, '');
      if (digits.length >= 11) {
        return `+${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
      }
      return phone;
    },
    onOptionsUpdate (opts) {
      const pageChanged = opts.page !== undefined && opts.page !== this.tableOptions.page;
      const perPageChanged = opts.itemsPerPage !== undefined && opts.itemsPerPage !== this.tableOptions.itemsPerPage;
      if (opts.page !== undefined) this.tableOptions.page = opts.page;
      if (opts.itemsPerPage !== undefined) {
        this.tableOptions.itemsPerPage = opts.itemsPerPage;
        this.pagination.per_page = opts.itemsPerPage;
      }
      if (pageChanged || perPageChanged) this.loadHistory();
    },
    async loadHistory () {
      this.loading = true;
      const clientId = this.$route.params.id;
      const params = {
        client_id: clientId ? Number(clientId) : undefined,
        date_from: this.dateFilter[0] || undefined,
        date_to: this.dateFilter[1] || undefined,
        action_type: this.filters.action_type || undefined,
        per_page: this.tableOptions.itemsPerPage || 15,
        page: this.tableOptions.page || 1,
      };
      try {
        const response = await this.getCarNumberChangesHistory(params);
        this.items = response.data || [];
        const pag = response.pagination || {};
        this.pagination = {
          current_page: pag.current_page ?? 1,
          last_page: pag.last_page ?? 1,
          per_page: pag.per_page ?? 15,
          total: pag.total ?? 0,
        };
      } catch (e) {
        console.error(e);
        this.$flash_warning('Не удалось загрузить журнал');
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.routerLink {
  text-decoration: none;
  color: inherit;
}
.routerLink:hover {
  text-decoration: underline;
}
</style>
